export const BETA_AGREEMENT_TITLE = "Repair Shop Beta Testing Agreement";
export const BETA_AGREEMENT_LAST_UPDATED = "March 1, 2026";

export const BETA_AGREEMENT_CONTENT = `OPTIBAY AI LLC — REPAIR SHOP BETA TESTING AGREEMENT

Thank you for agreeing to beta test the OptiBay App. Please read the following carefully. It includes terms that apply specifically to the beta test period.

TERMS WE USE

How we identify individuals and businesses:

• "You," or "your" refers to the automotive repair shop, whether a business entity or a sole proprietorship, that has agreed to be a beta test site.
• "User" means individual users of the software under your license.

Other terms:

• "Agreement" means this Beta Testing Agreement, the Repair Shop Terms of Service, available at https://www.optibayai.com/legal/terms, and our Privacy Policy, available at https://www.optibayai.com/legal/privacy.
• "App" means the OptiBay progressive web app.
• "Beta Test Period" means the period from your execution of our Agreement up to the public launch of the App.
• "Confidential Information" means the beta version(s) of the App any and all OptiBay AI non-public, proprietary information concerning the App that we provide to you or that is developed during the Beta Test Period. Confidential Information includes the pre-launch version of the App, any supporting documentation, beta test reports and feedback, and any other non-public information concerning the App and its development.

WHAT THIS BETA TESTING AGREEMENT COVERS

This Beta Testing Agreement includes special terms that apply to the Beta Test Period. The applicable Terms of Service and our Privacy Policy are part of our Agreement and are incorporated into this Beta Testing Agreement by reference. In the event of a conflict between these terms and the applicable Terms of Service or Privacy Policy, this Beta Testing Agreement takes precedence.

DISCLAIMERS

The primary purpose of beta testing is to get quantitative and qualitative feedback on the App's real time performance and to identify any unknown issues. Please use caution when beta testing and back up any essential information that you save in the App.

FEEDBACK

You agree to provide us with reasonable suggestions, comments and feedback regarding the OptiBay App, including but not limited to usability, bug reports and test results. Please see the attached testing and feedback instructions for further information.

5. LIMITED PURPOSE

During the Beta Test period, you agree that you and your Users will use the App and Confidential Information solely for the purpose of testing the App and providing feedback to us.

6. CONFIDENTIALITY

You agree that you and your Users will keep the App and other Confidential Information strictly confidential and will not disclose such Confidential Information to third parties without written authorization from OptiBay AI, until such time as such information is no longer confidential.

Testing reports and feedback will remain the Confidential Information of OptiBay AI after the Beta Test Period concludes unless subject to an exception.

Confidentiality obligations will not apply to any information that:

• you knew or possessed before the Beta Test Period;
• is or becomes public knowledge through no fault of yours or your Users;
• becomes available to you from a source not subject to confidentiality obligations;
• becomes available to you on a nonconfidential basis; or
• must be disclosed pursuant to a court or government order, provided that you give us notice and an opportunity to oppose the order.

DISCOUNT

Use of our App during the Beta Test Period is free. In exchange for participating in our beta test you will have the option to receive the following App subscription discounts after the Beta Test Period:

• Free for the first 60 days
• After the free period, 50% off list price for one year`;
